import store from '../../store'
import Web3 from 'web3'
import ZeroClientProvider from 'web3-provider-engine/zero.js'

export const WEB3_INITIALIZED = 'WEB3_INITIALIZED'
function web3Initialized(results) {
    return {
        type: WEB3_INITIALIZED,
        payload: results
    } 
}

let getWeb3 = new Promise(function(resolve) {
    // Wait for loading completion to avoid race conditions with web3 injection timing.
    window.addEventListener('load', function() {

        //let web3 = new Web3Old(new Web3Old.providers.HttpProvider('https://rinkeby.infura.io/v3/edf148d3211246adb2f4150f2395a64d'))
        
        let engine = ZeroClientProvider({
            getAccounts: function(){}, 
            rpcUrl: 'https://rinkeby.infura.io/v3/edf148d3211246adb2f4150f2395a64d'
        }) 

        let web3 = new Web3(engine); 
        
        let results = {
            web3Instance: web3
        }

        //console.log('No web3 instance injected, using Local web3.');

        resolve(store.dispatch(web3Initialized(results)))
        //}
    })
})

export default getWeb3



// WEBPACK FOOTER //
// ./src/util/web3/getWeb3.js